import React from 'react';
import { MenuItem, TextField } from '@material-ui/core';
// common validator for EntitySampleRelationConfigurator
export const EntitySampleRelationValidator = config => {
    const relation = !['randomize', 'null', null].includes(config.relation)
        ? 'Invalid value.'
        : undefined;
    return relation ? { relation } : undefined;
};
export const EntitySampleRelationConfigurator = props => {
    const { column, config, disabled, validate, onChange } = props;
    const errors = (validate === null || validate === void 0 ? void 0 : validate(config, column)) || {};
    const getValue = (value) => {
        return !value || value === 'null' ? null : 'randomize';
    };
    return (React.createElement(TextField, { select: true, fullWidth: true, size: 'small', label: 'Relation', variant: 'outlined', disabled: disabled, error: !!errors.relation, helperText: errors.relation, value: `${getValue(config.relation)}`, onChange: event => onChange === null || onChange === void 0 ? void 0 : onChange({ relation: getValue(event.target.value) }) },
        React.createElement(MenuItem, { value: 'null' }, "NULL"),
        React.createElement(MenuItem, { value: 'randomize' }, "Randomize")));
};
//# sourceMappingURL=EntitySampleRelationConfigurator.js.map